import { Control, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { IConfiguration } from "../../models";
import React, { useEffect, useState } from "react";
import { getServerListService } from "../../services/purecloud";
import RadioGroup from "@mui/material/RadioGroup";
import { AuthenticationType,RulesType } from "../../common/constants";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

interface S3StorageProps {
  register: any; // Adjust type as necessary, e.g., UseFormRegister<IConfiguration>
  control: Control<IConfiguration, any>;
  setValue: UseFormSetValue<IConfiguration>;
  watch: UseFormWatch<IConfiguration>;
  setSnackDetails: React.Dispatch<React.SetStateAction<{ open: boolean; message: React.ReactNode; severity: string }>>;
  setFormDataLoading: React.Dispatch<React.SetStateAction<boolean>>;
  serverList?: string[]; // Assuming serverList is an array of strings, adjust type as necessary
  selectedAdditionalAttribute:  string;
  setSelectedAdditionalAttribute: React.Dispatch<React.SetStateAction<string>>;
  handleAdditionalAttributesRadioChange: any;
}
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Autocomplete, TextField, Typography } from "@mui/material";
// import { getServerList } from "../../utils/serverUtils"; // Uncomment if you have a utility function to fetch server list

interface S3Listing {
  id: string,
  label: string
}

const S3Storage: React.FC<S3StorageProps> = (
  { register, control, setValue, watch, setSnackDetails, setFormDataLoading, serverList,selectedAdditionalAttribute,setSelectedAdditionalAttribute,handleAdditionalAttributesRadioChange }) => {

  const [getServerList, setServerList] = useState<Array<string>>([]);
  const [displayList, setDisplayList] = useState<Array<S3Listing>>([])

  useEffect(() => {
    const fetchServerList = async () => {
      try {
        const response = await getServerListService();
        console.log("Server List Response:", response);
        if (response && response.data && response.data.s3List) {
          setServerList(response.data.s3List);
          let s3Listing = response.data.s3List
          let s3RegionMap = s3Listing.map((item) => { return ({ "id": item, "label": item.split(":")[0] }) })
          console.log(s3RegionMap)
          setDisplayList(s3RegionMap)
        } else {
          console.error("Invalid server list response:", response);
        }
      }
      catch (error) {
        console.error("Error fetching server list:", error);
      }
    };
    fetchServerList();
  }, []);

  return (
    <>
      <h3 style={{ marginBottom: "20px" }}> S3 Configuration </h3>
      <div style={{display : "flex" , flexDirection: "column"}}>
      <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
      <Controller
        name="serverDetails.fileServer"
        control={control}
        render={({ field }) => (
          <Autocomplete
            disablePortal
            size="small"
            sx={{ width: "50%", padding: "0px 5px" }}
            options={displayList || []}
            value={displayList.find((option) => option.id === field.value) || null}
            onChange={(_event, newValue) => {
              setValue("serverDetails.fileServer", newValue ? newValue.id : "");
              setValue("serverDetails.password", "NA");
              setValue("serverDetails.port", 0);
              setValue("serverDetails.authenticationType", AuthenticationType.password);
              setValue("serverDetails.userName", "NA");
            }}
            renderInput={(params) => (
              <TextField {...params} label="S3 Bucket" />
            )}
          />
        )}
      />
      <TextField
        {...register("serverDetails.directory", {
          required: true,
        })}
        label="Directory *"
        value={watch("serverDetails.directory")}
        variant="outlined"
        size="small"
        sx={{ width: "50%", padding: "0px 5px" }}
      />
      </div>
          <div style={{ display: "flex", padding: "5px", marginTop: "20px"}}>

        {[RulesType.importFile, RulesType.importDNCList].includes(
          watch("rules.ruleType")
        ) && (
            <RadioGroup
              aria-label="additionalAttributes"
              name="additionalAttributes"
              value={selectedAdditionalAttribute}
              onChange={handleAdditionalAttributesRadioChange}
            >
              <FormControlLabel
                value="clearAll"
                control={<Radio />}
                label="None"
              />
              <FormControlLabel
                value="deleteFiles"
                control={<Radio />}
                label="Delete Files after import"
              />
              <FormControlLabel
                value="isMoveFiles"
                control={<Radio />}
                label="Move Files after import"
              />
              {selectedAdditionalAttribute === "isMoveFiles" && (
                <Controller
                  name="serverDetails.additionalAttributes.moveFiles.folderName"
                  control={control}
                  defaultValue={watch(
                    "serverDetails.additionalAttributes.moveFiles.folderName"
                  )}
                  rules={{ required: "Folder Name is required" }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Folder Name *"
                      variant="outlined"
                      size="small"
                      sx={{ width: "100%", padding: "5px 5px" }}
                    />
                  )}
                />
              )}
            </RadioGroup>
          )}
          </div>


</div>
    </>
  );
};

export default S3Storage;